import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { newResponsableSchema } from '@/shared';
import { useCreateResponsable, useUpdateResponsable } from '@/shared/actions/erp';
import {
  CustomTextField,
  ModelStateSelect,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { Responsable } from '@/shared/interfaces';


const returnUrl = '/activos/responsable';

export interface SaveResponsableInterface {
  titlePage: string;
  editResponsable?: Responsable;
}

type SaveFormData = {
  nombre: string;
  identificacion: string;
  estado: boolean;
};

const SaveResponsable: React.FC<SaveResponsableInterface> = ({ titlePage, editResponsable }) => {

  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);


  ///* mutations
  const createResponsableMutation = useCreateResponsable(navigate, returnUrl);
  const updateResponsableMutation = useUpdateResponsable(navigate, returnUrl);


  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newResponsableSchema),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editResponsable?.id_responsable) {
      return updateResponsableMutation.mutate({
        id: editResponsable.id_responsable,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createResponsableMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editResponsable) {
      setShrink(true);
      reset({
        nombre: editResponsable.nombre,
        identificacion: editResponsable.identificacion,
        estado: !!editResponsable.estado ? '1' : '0',
      } as any);
    }
  }, [editResponsable]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrl);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        register={register('nombre')}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink} name={'nombre'} />
      <CustomTextField
        label="Identificacion"
        register={register('identificacion')}
        error={errors.identificacion}
        helperText={errors.identificacion?.message}
        shrink={shrink} name={'Identificacion'} />
      <ModelStateSelect
        defaultValue={form.getValues().estado || ''}
        register={register('estado')}
        error={errors.estado}
        helperText={errors.estado?.message}
      />
    </SingleFormBoxScene>

  );
};

export default SaveResponsable;
